import axios from 'axios'
import BASE_URL from '@/config/api.js'


const ANSWER_URL = BASE_URL + "/api/prediction"


class AnswersResource {
    
    getAnswerAnd(question, consumer) {
        // Return the object to possibly handle the error
        return axios.post(ANSWER_URL, {input: question})
            .then(response => consumer(response.data.result))
    }

}

const answersApi = new AnswersResource()

export default answersApi
